module.exports = __webpack_public_path__ + "img/card_nevi_ElecrtrifyAmerica_1.3261d78c.png";